import { getStore as getMailStore } from '../../store/Store';

/**
 *  Tells if mail Reading Pane is currently visible
 */
export default function isReadingPaneVisible(): boolean {
    return !!getMailStore().mailModule.selectedId;
}
